module.exports = __webpack_public_path__ + "assets/images/project/head/Lalu_Muhammad_Zohri.jpg?v=c5469ba2";